import React from 'react';
import PropTypes from "prop-types";
import {getPlatform} from "@/hooks";

const BirthdatePicker = ({
    handleChange,
    baseClass,
    birthdate,
}) => {
    if (getPlatform() === 'web') {
        return (
            <div
                className={baseClass('-dob m2g-input-container')}
                data-icon-before
            >
                <input
                    type='date'
                    value={birthdate}
                    id='dob'
                    placeholder='YYYY/MM/DD'
                    required pattern="\d{4}-\d{2}-\d{2}"
                    className={baseClass('-dob-input m2g-input')}
                    onChange={(e) => handleChange(e.target.value)}
                />
                <span className="m2g-icon m2g-icon--calendar" />
            </div>
        );
    }

    return (
        <div
            className={baseClass('-dob m2g-list-cell')}
        >
            <span className='m2g-list-cell__icon m2g-icon m2g-icon--calendar' />
            <input
                className={baseClass('-dob-input m2g-list-cell__content m2g-touchable')}
                type='date'
                value={birthdate}
                placeholder='YYYY/MM/DD'
                required pattern="\d{4}-\d{2}-\d{2}"
                onChange={(e) => handleChange(e.target.value)}
            />
        </div>
    );
};

BirthdatePicker.propTypes = {
    baseClass: PropTypes.func.isRequired,
    birthdate: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
}

export default BirthdatePicker;
